import { StatusPill } from '../models/shared/status-pill';
import { MemberAccountStatus } from '../models/transactions/member-account-status';
import {
  AccountStatusPrimaryColors,
  AccountStatusSecondaryColors
} from '../models/enum/shared/member-account-status-colors';

export function buildAccountStatusPill(status: MemberAccountStatus): StatusPill {
  return new StatusPill(
    status.id,
    status.name,
    AccountStatusPrimaryColors[status.id],
    AccountStatusSecondaryColors[status.id]
  );
}
